import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { useParams } from 'react-router-dom';

import { addLusaHeaderParam, parseUrlParams } from '../../utils/parseUrlParams';
import Header from '../../components/Header';
import ApplicationId from '../../components/ApplicationId';

const Denied = ({ checkinData, navigate }) => {
  const match = useParams();
  const hardPullDisclosure = get(checkinData, 'data.data.hardPullDisclosure', get(checkinData, 'state.data.hardPullDisclosure'));
  const declineReason = get(checkinData, 'data.data.declinedReason', get(checkinData, 'state.data.declinedReason'));
  const strHeadLine = hardPullDisclosure ? 'Your loan status has changed. After further review, unfortunately we are no longer able to approve your application.' : 'Unfortunately, your application was not approved at this time.';
  const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');

  useEffect(() => {
    const params = parseUrlParams(window.location.search);

    if (get(checkinData, ['data']) === undefined && get(checkinData, ['state']) === undefined) {
      let routeUrl = `/${workflowType === 'dtm-luwa' ? 'luwa' : workflowType}/?key=${params.key}`;
      if (params.lusa_header && params.lusa_header === 'false') {
        routeUrl = addLusaHeaderParam(routeUrl);
      }
      navigate(routeUrl);
    }
  }, []);

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      {get(checkinData, 'attributes.entityId') ? (
        <ApplicationId id={get(checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
      ) : null}
      <div className="content">
        <h1>{strHeadLine}</h1>
        {declineReason && <p style={{ fontSize: 18 }}>{declineReason}</p>}
        <p>
          You will receive an adverse action notice within 30 days that will provide you with specific reason(s) as to why your application was not approved.
        </p>
      </div>
    </div>
  );
};

Denied.propTypes = {
  checkinData: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(Denied);
